<template>
  <div class="card shadow border-0 pb-3">
    <div class="card-body">
      <div class="row justify-content-between">
        <h3 class="col mb-3">Your Order</h3>
      </div>
      <div class="row justify-content-between mb-1">
        <div class="col-6">Net invoice value</div>
        <div class="col-6 text-right">{{transaction.net_amount | currency}}</div>
      </div>
      <div class="row justify-content-between mb-1">
        <div class="col-6">Amount covered</div>
        <div class="col-6 text-right">{{transaction.net_amount*0.9 | currency}}</div>
      </div>
      <div class="row justify-content-between mb-1">
        <div class="col-6">Counterparty</div>
        <div class="col-6 text-right" v-if="transaction.debtor">{{transaction.debtor.name}}</div>
      </div>
      <div class="row justify-content-between mb-1">
        <!-- TODO: this needs to change to Invoice term (e.g. 30 days) but needs Momentjs -->
        <div class="col-6">Invoice due date</div>
        <div class="col-6 text-right">{{transaction.due_date}}</div>
      </div>
      <hr>
      <div class="row justify-content-between text-muted">
        <div class="col-6 font-weight-bold">Premium</div>
        <div class="col-6 font-weight-bold text-right">{{quote.premium | currency}}</div>
      </div>
      <div class="row justify-content-between text-muted">
        <div class="col-6 font-weight-bold">IPT</div>
        <div class="col-6 font-weight-bold text-right">{{quote.ipt | currency}}</div>
      </div>
      <div class="row justify-content-between font-weight-bold mb-1 mt-2">
        <div class="col-6">Total cost of protection</div>
        <div class="col-6 h4 font-weight-bold text-right">{{quote.total_price | currency}}</div>
      </div>
      <div class="row justify-content-between mb-1">
        <p class="card-text col-12 text-muted">
        You will be entitled to cancel this policy within the first 72 hours and to receive a full refund provided your invoice has not already been settled, and you have not already made a claim.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'QuoteReceipt',
  props: ['quote', 'transaction']
}
</script>
